import axios from "axios";
import Config from "src/config";

const v2_getSpentMeses_action = (id) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${id}/consumo-meses`
    });
};

export default v2_getSpentMeses_action;
